<script>
export default {
    props: {
        item: { type: Object, default () {} }
    }
}
</script>
<template>
    <span>
        <span v-for="i in item.record" :key="i.key">
            <i style="opacity:0.5">{{ i.key }} :</i> <span>{{ i.value }}</span> <br/>
        </span>
    </span>
</template>